module.exports = __webpack_public_path__ + "static/img/home_foto1.81d4c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_foto1.png
// module id = 14
// module chunks = 0